// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Template404_wrapper__39nXf","wrapper-inner":"Template404_wrapper-inner__gKsL1","error-content":"Template404_error-content__hB2bZ"};